const FLAGS = {
  fr: (
    <>
      <rect width="6" height="14" fill="#0055A4" />
      <rect x="6" width="6" height="14" fill="#FFFFFF" />
      <rect x="12" width="6" height="14" fill="#EF4135" />
    </>
  ),
  en: (
    <>
      <rect width="18" height="14" fill="#012169" />
      <path d="M0 0 L18 14 M18 0 L0 14" stroke="#FFFFFF" strokeWidth="2.5" />
      <path d="M0 0 L18 14 M18 0 L0 14" stroke="#C8102E" strokeWidth="1" />
      <path d="M9 0 V14 M0 7 H18" stroke="#FFFFFF" strokeWidth="4" />
      <path d="M9 0 V14 M0 7 H18" stroke="#C8102E" strokeWidth="2" />
    </>
  ),
  de: (
    <>
      <rect width="18" height="4.67" fill="#000000" />
      <rect y="4.67" width="18" height="4.67" fill="#DD0000" />
      <rect y="9.33" width="18" height="4.67" fill="#FFCE00" />
    </>
  ),
  es: (
    <>
      <rect width="18" height="14" fill="#F1BF00" />
      <rect width="18" height="3.5" fill="#AA151B" />
      <rect y="10.5" width="18" height="3.5" fill="#AA151B" />
    </>
  ),
  it: (
    <>
      <rect width="6" height="14" fill="#009246" />
      <rect x="6" width="6" height="14" fill="#FFFFFF" />
      <rect x="12" width="6" height="14" fill="#CE2B37" />
    </>
  ),
  ru: (
    <>
      <rect width="18" height="4.67" fill="#FFFFFF" />
      <rect y="4.67" width="18" height="4.67" fill="#0039A6" />
      <rect y="9.33" width="18" height="4.67" fill="#D52B1E" />
    </>
  ),
  uk: (
    <>
      <rect width="18" height="7" fill="#005BBB" />
      <rect y="7" width="18" height="7" fill="#FFD500" />
    </>
  ),
  nl: (
    <>
      <rect width="18" height="4.67" fill="#AE1C28" />
      <rect y="4.67" width="18" height="4.67" fill="#FFFFFF" />
      <rect y="9.33" width="18" height="4.67" fill="#21468B" />
    </>
  ),
};

export const FlagIcon = ({ code, className = "" }) => (
  <svg
    viewBox="0 0 18 14"
    aria-hidden
    className={`w-[18px] h-[14px] shrink-0 rounded-[2px] border border-black/10 ${className}`}
  >
    {FLAGS[code]}
  </svg>
);
